module.exports = __webpack_public_path__ + "img/video-icon.af723555.png";